import { render, staticRenderFns } from "./CaseKPI.vue?vue&type=template&id=1d8b5d5f&"
import script from "./CaseKPI.vue?vue&type=script&lang=js&"
export * from "./CaseKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports